import setting from './setting';

export default {

  getOptions: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/acopio/parametros`, data, {headers:setting.http.headers()});
  },
  getListSolidos: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/portal/ganadero/lista/solidos/quincena`, data, {headers:setting.http.headers()});
  },
  getListUFC: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/portal/ganadero/lista/ufc/quincena`, data, {headers:setting.http.headers()});
  },
  getListSomaticas: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/portal/ganadero/lista/somatica/quincena`, data, {headers:setting.http.headers()});
  },
  getListTRAM: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/portal/ganadero/lista/tram/quincena`, data, {headers:setting.http.headers()});
  },
  downloadSolidos: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/portal/ganadero/lista/solidos/quincena/exportar`, data, {headers:setting.http.headers(), observe: 'response', responseType: 'arraybuffer'});
  },
  downloadUFC: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/portal/ganadero/lista/ufc/quincena/exportar`, data, {headers:setting.http.headers(), observe: 'response', responseType: 'arraybuffer'});
  },
  downloadSomaticas: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/portal/ganadero/lista/somatica/quincena/exportar`, data, {headers:setting.http.headers(), observe: 'response', responseType: 'arraybuffer'});
  },
  downloadTRAM: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/portal/ganadero/lista/tram/quincena/exportar`, data, {headers:setting.http.headers(), observe: 'response', responseType: 'arraybuffer'});
  },
  getListGrasa: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/portal/ganadero/lista/grasa/quincena`, data, {headers:setting.http.headers()});
  },
  getListProteina: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/portal/ganadero/lista/proteina/quincena`, data, {headers:setting.http.headers()});
  },
  getListUrea: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/portal/ganadero/lista/urea/quincena`, data, {headers:setting.http.headers()});
  },
  getListNul: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/portal/ganadero/lista/nul/quincena`, data, {headers:setting.http.headers()});
  },
  downloadGrasa: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/portal/ganadero/lista/grasa/quincena/exportar`, data, {headers:setting.http.headers(), observe: 'response', responseType: 'arraybuffer'});
  },
  downloadProteina: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/portal/ganadero/lista/proteina/quincena/exportar`, data, {headers:setting.http.headers(), observe: 'response', responseType: 'arraybuffer'});
  },
  downloadUrea: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/portal/ganadero/lista/urea/quincena/exportar`, data, {headers:setting.http.headers(), observe: 'response', responseType: 'arraybuffer'});
  },
  downloadNul: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/portal/ganadero/lista/nul/quincena/exportar`, data, {headers:setting.http.headers(), observe: 'response', responseType: 'arraybuffer'});
  },
  devolucionLecheList: ($axios, data)=>{
    return $axios.post(`${setting.http.base_url}/portal/ganadero/devolucion/leche`, data, {headers:setting.http.headers()});
  },
  devolucionLechePDF: ($axios, id)=>{
    return $axios.get(`${setting.http.base_url}/portal/ganadero/devolucion/leche/generar/pdf/${id}`, {headers:setting.http.headers(), responseType: 'blob'});
  },

}
